import { SvgIcon } from "@mui/material";
const Send = props => {
  return <SvgIcon viewBox="0 0 14 14" fill="none" {...props}>
      <path d="M9.68354 8.6384L11.406 6.38645L11.0638 9.29992L9.68354 8.6384Z" fill="#CBD5E1" stroke="#CBD5E1" strokeWidth="3.77953" />
      <path d="M3.93457 7.53057L5.48808 13.5L6.76926 9.33749L11.3002 3.41357L3.93457 7.53057Z" fill="#64748B" />
      <path d="M6.76952 9.3374L5.48828 13.5001L8.65431 10.2408L6.76952 9.3374Z" fill="#64748B" />
    </SvgIcon>;
};
export default Send;